import { useEffect, useState } from "react";
import GeneralSwiper from "../shared/swipers/GeneralSwiper";

interface SwiperImage {
	src: string;
	alt: string;
	id: number;
}

interface IImagesData {
	id: number;
	media_name: string;
	media_path: string;
	media_type: string;
	pivot: {
		media_device: string;
		order: number;
	};
}
const NeighborhoodsDetailsSwiper = ({
	images,
	paddingBottom,
	optimizedImage,
}: {
	images: IImagesData[];
	paddingBottom?: boolean;
	optimizedImage?: boolean;
}) => {
	const [orderedData, setOrderedData] = useState<IImagesData[]>([]);
	const [swiperImagesData, setSwiperImagesData] = useState<SwiperImage[]>([]);

	useEffect(() => {
		const sortedData = images?.sort((a, b) => a.pivot.order - b.pivot.order);
		setOrderedData(sortedData);
	}, [images]);

	useEffect(() => {
		const imagesStructured = orderedData?.map((image) => {
			return {
				src: process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL + image?.media_name,
				alt: image?.media_name,
				id: image?.id,
			};
		});
		setSwiperImagesData(imagesStructured);
	}, [orderedData]);

	return (
		<div
			className="nile_city_swiper"
			style={{ marginBottom: paddingBottom ? "6.25rem" : "" }}
		>
			<GeneralSwiper
				images={swiperImagesData}
				spaceBetween={50}
				slidesPerView={1.1}
				ImgHeight={"h-[30rem] md:h-[40rem]"}
				optimizedImage={optimizedImage}
			/>
		</div>
	);
};

export default NeighborhoodsDetailsSwiper;
